module.exports = __webpack_public_path__ + "img/mt20.c711e0fa.jpg";